import React, { useEffect, useState } from "react";
import TableWithSkeleton from "../../../../components/table/TableWithSkeleton";
import tradeColumns from "../../../../columns/trades.jsx";
import { GetOpenTradesApi } from "../../../../api/request/dashboard.js";

const OpenTrades = ({ loginId }) => {
  const [data, setData] = useState([]);

  const getOpenTrades = async () => {
    try {
      const { data } = await GetOpenTradesApi(loginId);
      if (data?.success) setData(data?.data);
    } catch (error) {}
  };

  useEffect(() => {
    if (loginId) getOpenTrades();
  }, [loginId]);

  return <TableWithSkeleton columns={tradeColumns} data={data} />;
};

export default OpenTrades;
